import {Report, IBlock} from '../../shared/models';
import {generateWebhookToken} from '../../shared/components/dialogs/Trigger';
import {REPORT_TYPE} from './constants';
import {typePathMap} from "../../shared/utils/typePathMap";

const _addZero = (value: number) => value < 10 ? ('0' + value) : value;

export const defaultReportName = (type?: string) => {
  const now = new Date();
  const today = (
    now.getFullYear() + '-' +
    _addZero(now.getMonth() + 1) + '-' +
    _addZero(now.getDate())
  ); // YYYY-MM-DD

  let name = 'Report ';
  if (type === REPORT_TYPE.NOTEBOOK) {
    name = 'Notebook ';
  } else if (type === REPORT_TYPE.TABLEAU_EMBED) {
    name = 'Tableau Dashboard Embed ';
  }

  return name + today;
};

export const createDefaultTableauEmbedBlock = (): Partial<IBlock> => {
  return {
    name: 'tableau_embed',
    verbose_name: 'tableau_embed',
    type: 'tableau_embed',
    content_json: JSON.stringify({
      id: Date.now(),
      integration_id: '',
      workbook_id: '',
      view_id: '',
      custom_view_id: ''
    })
  }
}

export const createEmtpyReport = (type?: string): Partial<Report> => {
  const options: any = {
    'destinations': []
  }
  const _type = type || REPORT_TYPE.REPORT;

  return  {
    name: defaultReportName(_type),
    options: JSON.stringify(options),
    type: type || REPORT_TYPE.REPORT,
  }
};

export const createReportWebhook = (id: number, email: string = '') => {
  const recipients = email !== '' ? [email] : [];
  const details = {
    notification: {
      success: false,
      failure: true,
    }
  };

  return {
    active: false,
    report_id: id,
    recipients,
    details,
    token: generateWebhookToken(),
  };
};

export const createReportWorkflow = (id: number, email: string = '') => {
  const recipients = email !== '' ? [email] : [];
  const profile = {
    notification: {
      success: false,
      failure: true,
    }
  };

  // rrule
  const tzId = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const now = new Date();
  const today = ('' + now.getFullYear() + _addZero(now.getMonth() + 1) + _addZero(now.getDate()));
  const rrule: string = `DTSTART;TZID=${tzId}:${today}T080000;\n` +
    `RRULE:FREQ=DAILY;INTERVAL=1;COUNT=10`

  return {
    active: false,
    report_id: id,
    recipients,
    profile,
    rrule,
  };
};

export const getEditPath = (type: REPORT_TYPE | string | undefined, uid: string): string => {
  /*
   * Used for URL
   */

  let typePath = typePathMap(type);

  return `/r/${typePath}edit/${uid}`;
};

export const extractBlockName = (attachment: string): string | null => {
  const match = attachment.match(/\{\{\s*(\w+)\.export/);
  return match ? match[1] : null;
};
